import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker so the browser exposes the "Add to Home
// Screen" install prompt on Android/Chrome + iOS Safari. We register after
// load so it never competes with initial render. We also force an update
// check and reload once a new SW takes control, so users never get stuck
// on a stale JS bundle after we ship a fix.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // Always check for a newer SW on every visit.
        reg.update().catch(() => {});
      })
      .catch(() => { /* ignore */ });

    // If a new SW takes control, refresh the page so the visitor immediately
    // sees the freshest JS. Guarded so it only ever fires once per session.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
